import { ChangeEvent, useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { Checkbox, SelectEvent } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";
import { CountySelect } from ".";

interface IProps {
  onChange: (e?: ChangeEvent<SelectEvent>) => void;
  excludeCountyIds: number[];
  value: number | null;
}

export const OtherInstitutionCounty = ({
  onChange,
  excludeCountyIds,
  value,
}: IProps) => {
  const [isOtherInstitutionCounty, setIsOtherInstitutionCounty] = useState(
    !!value
  );

  const [selectedCountyId, setSelectedCountyId] = useState<number | null>(
    value
  );

  useEffect(() => {
    if (!value || excludeCountyIds.includes(value)) return;

    setIsOtherInstitutionCounty(!!value);
    setSelectedCountyId(value);
  }, [value]);

  const { t } = useTranslation();

  const resetOnCountyChange = () => {
    setSelectedCountyId(null);
  };

  const handleSelectCounty = (e: ChangeEvent<SelectEvent>) => {
    const val = Number.parseInt(e.target.value);
    setSelectedCountyId(val);
    onChange(e);

    if (Number.isNaN(val)) resetOnCountyChange();
  };

  const handleInstitutionCountyChange = () => {
    const newFlag = !isOtherInstitutionCounty;
    setIsOtherInstitutionCounty(newFlag);
    onChange();

    resetOnCountyChange();
  };

  return (
    <>
      <Col md={6} style={{ marginTop: "1.5rem" }}>
        <Checkbox
          label={t("institutionDataStep.institutionOutsideCountyLabel")}
          onChange={handleInstitutionCountyChange}
          checked={isOtherInstitutionCounty}
        />
      </Col>
      {isOtherInstitutionCounty && (
        <Col md={6}>
          <CountySelect
            label={t("institutionDataStep.institutionOutsideContySelect")}
            value={selectedCountyId ?? undefined}
            onChange={handleSelectCounty}
            excludeCountyIds={excludeCountyIds}
          />
        </Col>
      )}
    </>
  );
};
